export default __webpack_public_path__ + "static/media/our-values-image-tablet.55c3ab82.jpg";